var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 10 11"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#file-edit-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 3.417V.692c.38.144.73.366 1.027.662L7.48 2.807c.296.296.518.646.663 1.026H5.417A.417.417 0 0 1 5 3.417m.53 5.2c-.34.338-.53.798-.53 1.277v.606h.606c.48 0 .939-.19 1.277-.53L9.72 7.136A.958.958 0 0 0 8.365 5.78zM4.166 9.894c0-.705.274-1.368.773-1.867l2.836-2.836c.162-.162.35-.286.554-.375q-.001-.075-.007-.15H5.417c-.69 0-1.25-.56-1.25-1.25V.51Q4.066.501 3.965.5H2.083A2.086 2.086 0 0 0 0 2.583v5.834C0 9.565.935 10.5 2.083 10.5h2.084z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "file-edit-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h10v10H0z"
})))));
export { SvgFileEditIcon as ReactComponent };
export default __webpack_public_path__ + "b10c83ecdf7c974ca27e975dad8985cd.svg";